import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DeviceInfo } from '../../../models/device-models/device-info-model/device-info.model';

@Component({
  selector: 'app-device-list-properties',
  templateUrl: './device-list-properties.component.html',
  styleUrls: ['./device-list-properties.component.scss']
})
export class DeviceListPropertiesComponent implements OnInit, OnChanges {

  @Input() deviceInfo: DeviceInfo;
  properties: Array<any>;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if ((changes.deviceInfo.previousValue === undefined ) && (changes.deviceInfo.currentValue !== undefined )) {
      this.properties = this.parseProperties();
    }
  }

  public parseProperties() {
    let properties = [];
    if (this.deviceInfo.Properties) {
      properties = Object.entries(JSON.parse(this.deviceInfo.Properties));
    }
    return properties;
  }
}
